/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { QuickRegisterRequest } from '../model';
// @ts-ignore
import { RegisterIntoMembershipRequest } from '../model';
// @ts-ignore
import { RegisterRequest } from '../model';
// @ts-ignore
import { RegisterResponse } from '../model';
/**
 * RegisterControllerApi - axios parameter creator
 * @export
 */
export const RegisterControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {QuickRegisterRequest} quickRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickRegister: async (quickRegisterRequest: QuickRegisterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quickRegisterRequest' is not null or undefined
            assertParamExists('quickRegister', 'quickRegisterRequest', quickRegisterRequest)
            const localVarPath = `/register/quick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quickRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerRequest: RegisterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('register', 'registerRequest', registerRequest)
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterIntoMembershipRequest} registerIntoMembershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerIntoMembership: async (registerIntoMembershipRequest: RegisterIntoMembershipRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerIntoMembershipRequest' is not null or undefined
            assertParamExists('registerIntoMembership', 'registerIntoMembershipRequest', registerIntoMembershipRequest)
            const localVarPath = `/register/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerIntoMembershipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegisterControllerApi - functional programming interface
 * @export
 */
export const RegisterControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegisterControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {QuickRegisterRequest} quickRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quickRegister(quickRegisterRequest: QuickRegisterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quickRegister(quickRegisterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerRequest: RegisterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterIntoMembershipRequest} registerIntoMembershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerIntoMembership(registerIntoMembershipRequest: RegisterIntoMembershipRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerIntoMembership(registerIntoMembershipRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegisterControllerApi - factory interface
 * @export
 */
export const RegisterControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegisterControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {QuickRegisterRequest} quickRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickRegister(quickRegisterRequest: QuickRegisterRequest, options?: any): AxiosPromise<RegisterResponse> {
            return localVarFp.quickRegister(quickRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerRequest: RegisterRequest, options?: any): AxiosPromise<RegisterResponse> {
            return localVarFp.register(registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterIntoMembershipRequest} registerIntoMembershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerIntoMembership(registerIntoMembershipRequest: RegisterIntoMembershipRequest, options?: any): AxiosPromise<void> {
            return localVarFp.registerIntoMembership(registerIntoMembershipRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegisterControllerApi - object-oriented interface
 * @export
 * @class RegisterControllerApi
 * @extends {BaseAPI}
 */
export class RegisterControllerApi extends BaseAPI {
    /**
     * 
     * @param {QuickRegisterRequest} quickRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterControllerApi
     */
    public quickRegister(quickRegisterRequest: QuickRegisterRequest, options?: AxiosRequestConfig) {
        return RegisterControllerApiFp(this.configuration).quickRegister(quickRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterRequest} registerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterControllerApi
     */
    public register(registerRequest: RegisterRequest, options?: AxiosRequestConfig) {
        return RegisterControllerApiFp(this.configuration).register(registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterIntoMembershipRequest} registerIntoMembershipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterControllerApi
     */
    public registerIntoMembership(registerIntoMembershipRequest: RegisterIntoMembershipRequest, options?: AxiosRequestConfig) {
        return RegisterControllerApiFp(this.configuration).registerIntoMembership(registerIntoMembershipRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

